import { createContext, useCallback, useContext } from 'react'

const TrailerSeekTimeContext = createContext(new Map())

/** Returns the seek time at mount time, but not real-time updates */
export const useTrailerSeekTime = (slug) => {
  const seekTimes = useContext(TrailerSeekTimeContext)
  return {
    initialSeekTime: useContext(TrailerSeekTimeContext).get(slug) ?? 0,

    captureSeekTime: useCallback(
      (seekTime, duration) => {
        const hasFinished = duration && seekTime / duration > 0.92
        seekTimes.set(slug, hasFinished ? 0 : seekTime)
      },
      [slug, seekTimes],
    ),
  }
}
